<template>
  <vue-dropzone
    :ref="name"
    :id="id"
    :options="dropzoneOptions"
    :destroyDropzone="false"
    @vdropzone-sending="vsending"
    @vdropzone-success="vsuccess"
    @vdropzone-removed-file="vremoved"
    @vdropzone-mounted="vmounted">
  </vue-dropzone>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: 'dropzone-upload',
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: []
    },
    id: {
      type: String,
      default: ''
    },
    url: String,
    aditionalParams: {
      type: Object,
      default: {}
    },
    maxFiles: {
      default: 8
    },
    acceptedFiles: {
      default: 'image/*,application/pdf'
    }
  },
  data() {
    return {
      visible: false,
      dropzoneOptions: {
        dictDefaultMessage: 'Arraste seus arquivos aqui<br><small>ou clique para fazer o upload</small>',
        dictMaxFilesExceeded: 'Você não pode adicionar mais arquivos',
        dictRemoveFile: 'Remover',
        dictCancelUpload: 'Cancelar',
        dictFileTooBig: 'O arquivo é muito grande. Envie arquivos de até {{maxFilesize}}MB.',
        dictRemoveFileConfirmation: 'Confirma a remoção do arquivo?',
        dictCancelUploadConfirmation: 'Confirma o cancelamento do upload?',
        url: this.url,
        thumbnailHeight: 144,
        addRemoveLinks: true,
        acceptedFiles: this.acceptedFiles,
        maxFiles: this.maxFiles,
        maxFilesize: 10,
        headers: {
          'Authorization': this.$store.state.token
        }
      }
    };
  },
  methods: {
    vsending(file, xhr, formData) {
      if (this.aditionalParams) {
        let keys = Object.keys(this.aditionalParams);

        keys.map(key => {
          let value = this.aditionalParams[key];
          formData.append(key, value);
        });
      }
    },
    vremoved(file, error, xhr) {
      this.value.filter((arquivo, i) => {
        if (arquivo.name == file.name) {
          this.value.splice(i, 1);

          if (arquivo.id) {
            let removed = {
              id: arquivo.id,
              path: file.name
            };

            this.$emit('fileRemoved', removed);
          }
        }
      });
    },
    vsuccess(file, response) {
      let result = response.file;
      result.id = response.result.id;

      this.value.push(result);

      this.$emit('fileAdded', result);
    },
    vmounted() {
      let app = this;

      this.value.forEach(function(file) {
        let url = file.path;

        let mocked = {
          id: file.id,
          size: file.size,
          name: file.name
        };

        let extension = url.split('.').pop();

        if (extension == 'png' || extension == 'jpg' || extension == 'jpeg') {
          url = app.$http.options.root + url;
        } else {
          url = '';
        }

        app.$refs[app.name].manuallyAddFile(mocked, url);
      });
    }
  }
};
</script>

<style>
.vue-dropzone {
  -webkit-border-radius: 4px !important;
  -moz-border-radius: 4px !important;
  border-radius: 4px !important;
  border: 2px dashed #e5e5e5 !important;
  font-family: 'RobotoRegular', Helvetica, sans-serif !important;
}

.vue-dropzone.required {
  border-color: #1caf9a !important;
}

.dropzone {
  min-height: 220px !important;
}

.dropzone .dz-message {
  margin: 4em 0 !important;
  font-size: 16px !important;
  font-family: 'RobotoBold', Helvetica, sans-serif !important;
}

.dropzone .dz-message small {
  font-size: 14px !important;
  font-family: 'RobotoLight', Helvetica, sans-serif !important;
}

.dropzone .dz-preview .dz-image img {
  height: 144px !important;
}

.vue-dropzone .dz-preview .dz-image img:not([src]) {
  height: 144px !important;
  width: 144px !important;
}

.vue-dropzone .dz-preview .dz-details {
  background-color: rgb(28, 175, 154) !important;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.vue-dropzone .dz-preview .dz-image {
  -webkit-border-radius: 4px !important;
  -moz-border-radius: 4px !important;
  border-radius: 4px !important;
}

.vue-dropzone .dz-preview .dz-remove {
  background-color: #d9534f;
  border: 1px solid #d43f3a !important;
  -webkit-border-radius: 3px !important;
  -moz-border-radius: 3px !important;
  border-radius: 3px !important;
  line-height: 21px !important;
  -moz-transition: all 0.2s ease-out 0s !important;
  -webkit-transition: all 0.2s ease-out 0s !important;
  transition: all 0.2s ease-out 0s !important;
  padding: 4px 10px !important;
  text-transform: none !important;
  font-size: 12px !important;
  font-weight: normal !important;
  letter-spacing: normal !important;
}

.dropzone .dz-preview .dz-remove:hover {
  text-decoration: none !important;
  color: #fff !important;
  background-color: #d2322d !important;
  border-color: #ac2925 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/DropzoneUpload.vue